import React from 'react';
import { LinkProps, Link } from 'react-router-dom';
import { generatePathOrReturnAbsoluteLink } from '../../../lib';
import { onLpRedirect } from '../../../lib/landingPage';

type ToProps = { to: string };
type BaseLpLinkProps = Omit<LinkProps, 'to'>;
export type LpLinkProps = BaseLpLinkProps & Partial<ToProps>;

const RequiredToLink = (props: BaseLpLinkProps & ToProps) => {
    return (
        <Link
            {...props}
            onClick={event => {
                const openedInNewTab = event.ctrlKey;
                if (!openedInNewTab) onLpRedirect(props.to);
                props.onClick && props.onClick(event);
            }}
        />
    );
};

export const LpLink = (props: LpLinkProps): JSX.Element => {
    return props.to ? (
        <RequiredToLink
            {...props}
            to={generatePathOrReturnAbsoluteLink(props.to)}
        />
    ) : (
        <a {...props} href={props.to}>
            {props.children}
        </a>
    );
};
